<template>
  <div class="white storage-search-custom-select py-2">
    <div class="pl-4 pr-2 secondary--text">
      <div class="d-flex flex-column ">
        <span class="grey--text font-weight-medium mb-1">{{
          $t("storage.file_names")
        }}</span>
        <span
          @click="handleSearch('byFileName')"
          :class="{
            'storage-search-custom-select__option': true,
            'storage-search-custom-select__option--selected': isFileNameSelected
          }"
        >
          {{
            `${$t("storage.matching_names")}: ${storageSearchInputValue}`
          }}</span
        >
      </div>

      <div v-if="!noResults" class="d-flex flex-column">
        <v-divider class="my-2" />
        <span class="grey--text font-weight-medium mb-1">{{
          $t("storage.tags")
        }}</span>
        <div
          v-if="!isLoading"
          class="d-flex flex-column pr-1 storage-search-custom-select__tags"
        >
          <span
            v-for="tag in tags"
            :key="tag.id"
            @click="handleSearch('byTagName', tag)"
            :class="{
              'storage-search-custom-select__option flex-grow-1 mb-1': true,
              'storage-search-custom-select__option--selected': isTagSelected(
                tag
              )
            }"
            >{{ tag.tag }}</span
          >
        </div>
        <v-progress-circular
          v-else
          indeterminate
          color="primary"
          size="20"
          width="2"
          class="align-self-center my-1"
        ></v-progress-circular>
      </div>
    </div>
  </div>
</template>

<script>
import { ModuleTypes } from "@/store/ModuleTypes";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { debounce } from "lodash";

export default {
  name: "StorageSearchCustomSelect",
  data: () => ({
    tags: [],
    isLoading: false,
    noResults: false
  }),

  props: {
    toggleSelectVisible: {
      type: Function,
      required: true
    },
    handleSelectedTags: {
      type: Function,
      default: null
    },
    handleChangeFileName: {
      type: Function,
      default: null
    },
    handleSearchingInfoShow: {
      type: Function,
      default: null
    },
    selectedTags: {
      type: Array,
      default: null
    },
    fileName: {
      type: String,
      required: true
    }
  },

  computed: {
    ...mapGetters(ModuleTypes.STORAGE, [
      "storageSearchInputValue",
      "storageContent",
      "currentStorageBreadcrumbs"
    ]),

    isFileNameSelected() {
      return this.storageSearchInputValue === this.fileName;
    }
  },

  methods: {
    ...mapActions(ModuleTypes.STORAGE, ["fetchStorageContent"]),
    ...mapActions(ModuleTypes.STORAGE_ITEM_DETAILS, ["searchTags"]),
    ...mapMutations(ModuleTypes.STORAGE, ["setStorageSearchInputValue"]),

    async handleSearch(option, tag) {
      this.toggleSelectVisible(false);
      if (option === "byTagName") {
        !this.fileName && this.setStorageSearchInputValue("");
        if (tag?.id && !this.selectedTags?.find(item => item?.id === tag?.id)) {
          await this.handleSelectedTags([...this.selectedTags, tag]);
        } else {
          const filteredTags = this.selectedTags?.filter(
            item => item?.id !== tag?.id
          );
          await this.handleSelectedTags(filteredTags);
        }
      } else if (option === "byFileName") {
        await this.handleChangeFileName(
          !this.fileName ? this.storageSearchInputValue : ""
        );
        !this.fileName && this.setStorageSearchInputValue("");
      }
      this.fileName || this.selectedTags?.length
        ? this.handleSearchingInfoShow(true)
        : this.handleSearchingInfoShow(false);
      this.fetchContent();
    },

    isTagSelected(tag) {
      return this.selectedTags?.find(item => item.id === tag?.id);
    },

    fetchContent() {
      const breadcrumbs = this.storageContent?.breadcrumbs;
      const selectedTagsIds = this.selectedTags?.map(item => item?.id);
      this.fetchStorageContent({
        organizationId:
          this.$route.params?.organizationId || this.$route.params.orgId,
        parentId: breadcrumbs?.[breadcrumbs?.length - 1]?.id,
        playerId: null,
        searchValue: this.fileName ? this.fileName : null,
        tags: selectedTagsIds?.length ? selectedTagsIds : null,
        sharedWithMe: breadcrumbs?.[breadcrumbs?.length - 1]?.sharedWithMe
      });
    },

    checkStorageSearchInputValue: debounce(async function(newValue) {
      await this.searchTags({
        filter: newValue,
        callback: res => {
          this.tags = res?.tags;
          this.noResults = !res?.tags?.length;
        }
      });
      this.isLoading = false;
    }, 500)
  },

  watch: {
    storageSearchInputValue(newValue) {
      if (
        !this.$route.params?.playerId &&
        newValue?.length >= 3 &&
        newValue?.length <= 50
      ) {
        this.isLoading = true;
        this.checkStorageSearchInputValue(newValue);
      }
    }
  }
};
</script>

<style scoped>
.storage-search-custom-select {
  margin-top: 4px;
  border-radius: 20px;
  z-index: 10;
}

.pointer {
  cursor: pointer;
}

.storage-search-custom-select__option {
  padding: 4px 12px;
  border-radius: 20px;
  cursor: pointer;
  word-break: break-all;
}

.storage-search-custom-select__option--selected,
.storage-search-custom-select__option:hover {
  background-color: var(--primary-color--light);
}

.storage-search-custom-select__tags {
  max-height: 200px;
  overflow: auto;
}
</style>
